import Infographic from './Infographic'

export default Infographic